<template>
  <v-col cols="12" sm="12" md="12" lg="12">
    <v-card v-if="searchData.startsWith('#')">
      <v-toolbar color="primary" dark height="43px">
        <v-icon size="18" class="mr-2">mdi-tag</v-icon>
        <span> {{ $t("agenda.lblTag") }} &nbsp; - &nbsp; {{searchData}}</span>
      </v-toolbar>
      <v-data-iterator
        :items="filteredMeetingList"
        :page.sync="page"
        :items-per-page="10"
        :loading="isloading"
        :loading-text="$t('LoaderText')"
        :footer-props="{
          'items-per-page-text': $t('lblRowsPerPage'),
        }"
        :no-data-text="$t('noData')"
        :no-results-text="$t('emptySearchRecords')"
      >
        <template v-slot:default="props">
          <v-row no-gutters class="py-1">
            <v-col
              v-for="(item, index) in props.items"
              :key="index"
              cols="12"
              sm="12"
              md="12"
              lg="12"
              style="padding: 3px 8px;"
            >
              <tag-search
                :meetData="item"
              />
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-card>
    <v-card flat v-else>
      <!-- <v-row>
        <v-pagination v-model="page" :length="pageLength"></v-pagination>
      </v-row> -->
      <!-- <v-row> -->
      <v-data-iterator
        :items="filteredMeetingList"
        :page.sync="page"
        :items-per-page="10"
        :loading="isloading"
        :loading-text="$t('LoaderText')"
        :footer-props="{
          'items-per-page-text': $t('lblRowsPerPage'),
        }"
        :no-data-text="$t('noData')"
        :no-results-text="$t('emptySearchRecords')"
      >
        <template v-slot:default="props">
          <v-row class="mt-1">
            <v-col
              v-for="(item, index) in props.items"
              :key="index"
              cols="12"
              sm="12"
              md="12"
              lg="12"
              style="padding: 10px 6px 7px;"
            >
              <v-card
                class="mx-auto"
                max-width="100%"
                raised
                elevation="3"
                :to="
                  !item.isDeleted
                    ? `/meeting/${item.id}/search/tenant/${tenantId}`
                    : ''
                "
                min-height="65"
              >
                <v-card-text class="pl-3">
                  <v-row>
                    <v-col cols="12" sm="12" md="5" lg="6" class="pa-1">
                      <div class="overline" :style="textColorStyle(item)">
                        <v-icon color="darkCharcoal" right left size="20" :dark="isDarkTheme(item)"
                          >mdi-calendar-clock</v-icon
                        >{{ getTimeDetails(item) }}
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="3" class="pa-1">
                      <div class="overline" :style="textColorStyle(item)">
                        <v-icon color="darkCharcoal" right left size="20" :dark="isDarkTheme(item)"
                          >mdi-map-marker</v-icon
                        >
                        {{ item.location }}
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" lg="3" class="pa-1">
                      <a-chip
                        style="color: #333333"
                        class="minute mChip mt-1"
                        label
                        dark
                        small
                        outlined
                        :color="shadeColor(item.meetingType.color, -25)"
                        >{{ item.meetingType.label }}</a-chip
                      >
                    </v-col>
                  </v-row>
                  <v-list-item>
                    <div class="ml-3 text-h6" :style="textColorStyle(item)">
                      <h5 style="font-weight: 700; font-size: 16px; color: #333333; word-break: break-word;">{{ getMeetingName(item.meetingName) }}</h5>
                    </div>
                    <!-- <v-chip
                      v-if="item.isDeleted"
                      class="ml-2"
                      x-small
                      color="error"
                      outlined
                    >
                      Deleted
                    </v-chip> -->
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
      <!-- </v-row> -->
    </v-card>
  </v-col>
</template>

<script>
import { Internationalization } from "@syncfusion/ej2-base";
import customFunctions from "@/codeFiles/taskHelper.js";
import { mapGetters, mapState } from "vuex";
import TagSearch from "@/components/search/TagSearch.vue";

export default {
  name: "MeetingSearchCard",
  data() {
    return {
      intl: new Internationalization(),
      page: 1,
      isloading: false,
      pageSize: 10,
      searchData: ''
    };
  },
  components: { TagSearch },
  props: {
    data: Array,
  },
  computed: {
    ...mapState({
      meetingListData: (state) => state.meeting.meetingsList,
      searchText: (state) => state.search.searchText,
      agendaListData: (state) => state.agenda.agendaList,
    }),
    ...gettersMap(),
    loadtext() {
      this.isloading = true;
      return this.meetinglist.length > 0
        ? this.$t("LoaderText")
        : this.$t("noData");
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    meetingData() {
      return this.data || [];
    },
    meetinglist() {
      const data = this.meetingData.map((item) => ({
        ...item,
        title: item.meetingName,
        meetingType: this.meetingTypesList.find(
          (c) =>
            String(c.label).toLowerCase() ===
            String(item.meetingType).toLowerCase()
        ) || { label: item.meetingType, color: "#F5CBA7" },
      }));

      data.sort(function (a, b) {
        return (
          new Date(a.scheduletStartTimeInUTC) -
          new Date(b.scheduletStartTimeInUTC)
        );
      });

      return data;
    },
    filteredMeetingList() {
      let list = this.meetinglist.map((obj) => {
        return {
          ...obj,
          isDeleted: !this.meetingListData.some((item) => item.id === obj.id),
        };
      });
      
      if(this.searchData.startsWith('#')) {
        list.forEach((meeting) => {
          meeting.topics.map((topic) => {
            const agendaData = this.agendaListData.find(
              (agenda) => agenda.id === topic.agendaId
            );
            if(agendaData) {
              topic.agendaName = agendaData.agendaName;
            }
          })
          return meeting;
        });  
      }
      return list;
    },
    pageLength() {
      return this.data.count < this.pageSize
        ? 1
        : Math.ceil(this.data.count / this.pageSize);
    },
  },
  mounted() {
    if(this.searchText.startsWith('#')) {
      this.searchData = this.searchText;
    }
  },
  methods: {
    getMeetingName(name) {
      if (name && name.length > 150) {
        return name.slice(0, 150) + "...";
      }
      else {
        return name;
      }
    },
    shadeColor(color, percentage) {
      return customFunctions.shadeColor(color, percentage);
    },
    isDarkTheme(item) {
      return customFunctions.getContrast(this.backgroundColor(item));
    },
    textColorStyle(item) {
      return this.isDarkTheme(item) ? "color:white" : "color:black";
    },
    backgroundColor(item) {
      return customFunctions.shadeColor(item.meetingType.color, 130);
    },
    getTimeDetails(mDetails) {
      return (
        this.intl.formatDate(new Date(mDetails.scheduletStartTimeInUTC), {
          type: "date",
          skeleton: "long",
        }) +
        " (" +
        this.intl.formatDate(new Date(mDetails.scheduletStartTimeInUTC), {
          skeleton: "hm",
        }) +
        " - " +
        this.intl.formatDate(new Date(mDetails.scheduledEndTimeInUTC), {
          skeleton: "hm",
        }) +
        ")"
      );
    },
  },
};

function gettersMap() {
  return mapGetters({
    meetingTypesList: "tenant/agendaMeetingTypes",
  });
}
</script>

<style scoped>
::v-deep .v-card__text {
  padding: 0px;
}
::v-deep .v-list-item {
  min-height: 0;
}
.overline {
  line-height: 18px !important;
  font-family: 'Noto Sans JP' !important;
  font-size: 14px !important;
  color: #333333 !important;
}
</style>